export const authorizedKeyCodes = [
  "Enter",
  "NumpadEnter",
  ...Array.from(Array(9 + 1).keys()).map((number) => `Numpad${number}`),
];

export type PriceCalculatorInput = {
  value: number | null;
  error?: string;
};

export const INITIAL_INPUT: PriceCalculatorInput = {
  value: null,
};
